import { Badge, Button, DropdownMenu, Tooltip } from "@bigbinary/neeto-atoms";
import { SidebarMenuItem } from "@bigbinary/neeto-atoms/primitives";
import { Ellipsis } from "lucide-react";
import { useTranslation } from "react-i18next";

import CheckPointNavLinks from "./CheckPointNavLink";
import PinIcon from "./PinIcon";
import UnpinIcon from "./UnpinIcon";

import { filterByPermissions } from "../utils";

const MoreDropdown = ({ moreNavLinks, isNavLinkPinned, handleTogglePin }) => {
  const { t } = useTranslation();
  const isRTL = document.documentElement.dir === "rtl";

  return (
    <SidebarMenuItem>
      <DropdownMenu
        closeOnSelect={false}
        position={isRTL ? "left-start" : "right-start"}
        customTarget={
          <button
            className="text-sidebar-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground flex w-full items-center gap-2 rounded-md p-2 text-sm outline-hidden"
            data-testid="more-nav-links-dropdown-button"
          >
            <Ellipsis />
            <span className="truncate">{t("neetoMolecules.sidebar.more")}</span>
          </button>
        }
        dropdownProps={{
          className: "z-[99999] p-0",
          "data-testid": "more-nav-links-dropdown-menu",
        }}
      >
        {moreNavLinks.filter(filterByPermissions).map((navLink, index) => {
          const { label, icon, key: navLinkKey, to, onClick, tag } = navLink;
          const IconSVG = icon;
          const isPinned = isNavLinkPinned(navLink);

          return (
            <DropdownMenu.MenuItem
              data-testid={label}
              key={navLinkKey || index}
              onSelect={e => e.preventDefault()}
            >
              <CheckPointNavLinks
                {...{ onClick, to }}
                className="flex w-full cursor-pointer items-center justify-between gap-2 px-2 py-1"
              >
                <span className="flex min-w-0 flex-grow items-center gap-2">
                  {icon && <IconSVG className="flex-shrink-0" size={20} />}
                  <span className="flex min-w-0 flex-grow items-center gap-2">
                    {label}
                    {tag && <Badge {...tag} />}
                  </span>
                </span>
                <Tooltip
                  position="right"
                  content={
                    isPinned
                      ? t("neetoMolecules.sidebar.unpin")
                      : t("neetoMolecules.sidebar.pin")
                  }
                >
                  <Button
                    className="flex-shrink-0"
                    data-testid="pin-button"
                    size="icon-sm"
                    variant="ghost"
                    onClick={event => handleTogglePin(navLink, event)}
                  >
                    {isPinned ? (
                      <UnpinIcon otherProps={{}} size={16} />
                    ) : (
                      <PinIcon otherProps={{}} size={16} />
                    )}
                  </Button>
                </Tooltip>
              </CheckPointNavLinks>
            </DropdownMenu.MenuItem>
          );
        })}
      </DropdownMenu>
    </SidebarMenuItem>
  );
};

export default MoreDropdown;
